import { Badge } from "@/components/ui/badge";
import { Sparkles, User } from "lucide-react";

export type StepSource = "manual" | "ai_generated";

export function SourceBadge({ source }: { source: StepSource }) {
  if (source === "ai_generated") {
    return (
      <Badge variant="secondary" className="gap-1" data-testid="badge-source-ai">
        <Sparkles className="w-3 h-3" />
        AI Generated
      </Badge>
    );
  }
  return (
    <Badge variant="outline" className="gap-1" data-testid="badge-source-manual">
      <User className="w-3 h-3" />
      Manual
    </Badge>
  );
}
